// extracted by mini-css-extract-plugin
export default {"container":"Categories_container__lOehx"};